// extracted by mini-css-extract-plugin
module.exports = {"root":"ClearentDisclaimer_root__3Hq5L","header":"ClearentDisclaimer_header__qP__N","inner":"ClearentDisclaimer_inner__2JJfx"};